import React from 'react';

import { useExclusions } from '../api/getExclusions';
import { useSupplierExclusions } from '../api/getSupplierExclusions';
import { useUpdateSupplierExclusion } from '../api/updateSupplierExclusion';
import { ExclusionMatrices } from './ExclusionMatrices';
import { hasExclusion } from './ExclusionMatrix';

const resource = 'framework_agreements';

export const SupplierExclusionsView = ({ id, lot, supplier }) => {
  const { data: globalExclusions } = useExclusions(resource, id, lot.lot_id);
  const { data: exclusions, refetch } = useSupplierExclusions(id, lot.lot_id, supplier.fac_id);
  const { mutateAsync: updateExclusion } = useUpdateSupplierExclusion(
    id,
    lot.lot_id,
    supplier.fac_id
  );

  const isLocked = (roleId, levelId) => hasExclusion(globalExclusions, roleId, levelId);

  return (
    <ExclusionMatrices
      resource={resource}
      id={id}
      lotId={lot.lot_id}
      isLocked={isLocked}
      lockedTitle="Excluded for all suppliers"
      isExcluded={(roleId, levelId) =>
        isLocked(roleId, levelId) || hasExclusion(exclusions, roleId, levelId)
      }
      onToggle={(roleId, levelId, excluded) =>
        updateExclusion({ role_id: roleId, level_id: levelId, excluded }).then(() => refetch())
      }
    />
  );
};
